import { Injectable } from '@angular/core';

@Injectable()
export class AuthService {
  getToken() {
    return localStorage.getItem('auth_token');
  }
}
